import { useState } from 'react';
import { registerPlayer, loginPlayer } from '../../services/api';
import './PlayerSetup.css';

function PlayerSetup({ onPlayerCreated }) {
  const [mode, setMode] = useState('login'); // 'login' oder 'register'
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError(null);
    if (!name.trim() || !password) {
      setError('Bitte Name und Passwort eingeben.');
      return;
    }
    setLoading(true);
    try {
      const player = mode === 'login'
        ? await loginPlayer(name, password)
        : await registerPlayer(name, password);
      onPlayerCreated(player);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSubmit();
  };

  return (
    <div className="player-setup">
      <div className="shield-icon">🛡️</div>
      <h2>Phishing-Simulation</h2>
      <p>Trainiere deinen Blick für gefährliche Mails.</p>

      <div className="mode-switch">
        <button
          className={mode === 'login' ? 'active' : ''}
          onClick={() => { setMode('login'); setError(null); }}
        >
          Login
        </button>
        <button
          className={mode === 'register' ? 'active' : ''}
          onClick={() => { setMode('register'); setError(null); }}
        >
          Registrieren
        </button>
      </div>

      <input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder="Dein Name"
        autoFocus
      />
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder="Passwort"
      />
      <button onClick={handleSubmit} disabled={loading}>
        {loading ? '...' : mode === 'login' ? 'Einloggen →' : 'Registrieren →'}
      </button>
      {error && <p className="error">{error}</p>}
    </div>
  );
}

export default PlayerSetup;